import { useCallback } from 'react';
import { PopoverPosition } from '../types';
import { useScrollLock } from 'usehooks-ts';

export function useHandleOpen({
  isMobile,
  activeHover,
  isOpen,
  calculatePosition,
  setCurrentPosition,
  setIsOpen,
  setIsHover,
}: {
  isMobile: boolean;
  activeHover: boolean;
  isOpen: boolean;
  calculatePosition: () => PopoverPosition;
  setCurrentPosition: (position: PopoverPosition) => void;
  setIsOpen: (isOpen: boolean) => void;
  setIsHover: (isHover: boolean) => void;
}) {
  const { lock, unlock } = useScrollLock({ autoLock: false });
  return useCallback(
    (newOpenState: boolean) => {
      if (newOpenState && !isOpen) {
        // Calculate position before showing
        const calculatedPosition = calculatePosition();
        setCurrentPosition(calculatedPosition);

        // Allow position to update before showing
        setIsOpen(true);
        setIsHover(true);
        if (isMobile) lock();
      } else if (!newOpenState && isOpen) {
        setIsOpen(false);
        setIsHover(false);
        if (isMobile) unlock();
      }
    },
    [isOpen, isMobile, calculatePosition, lock, unlock, setCurrentPosition, setIsOpen, setIsHover],
  );
}
